import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { colors } from '../styles/GlobalStyles';
import { Button } from '../components/Button';
import { Input, Label, FormGroup, ErrorMessage } from '../components/Input';
import { authService } from '../services/authService';
import { toast } from 'react-toastify';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const Card = styled.div`
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px ${colors.shadow};
  max-width: 500px;
  width: 100%;
`;

const Title = styled.h2`
  color: ${colors.primary};
  margin-bottom: 10px;
  text-align: center;
`;

const Description = styled.p`
  color: ${colors.textLight};
  margin-bottom: 30px;
  text-align: center;
`;

const BackButton = styled.button`
  background: none;
  color: ${colors.primary};
  font-size: 14px;
  text-decoration: underline;
  margin-top: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;

  &:hover {
    opacity: 0.8;
  }
`;

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.forgotPassword(email);
      setSuccess(true);
      toast.success('Şifre sıfırlama linki email adresinize gönderildi');
    } catch (err) {
      setError(err.response?.data?.error || 'Bir hata oluştu');
      toast.error(err.response?.data?.error || 'Bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <Container>
        <Card>
          <Title>Email Gönderildi</Title>
          <Description>
            Şifre sıfırlama linki email adresinize gönderildi.
            Lütfen email kutunuzu kontrol edin.
          </Description>
          <Button fullWidth onClick={() => navigate('/')}>
            Giriş Sayfasına Dön
          </Button>
        </Card>
      </Container>
    );
  }

  return (
    <Container>
      <Card>
        <Title>Şifremi Unuttum</Title>
        <Description>
          Email adresinizi girin, size şifre sıfırlama linki gönderelim.
        </Description>

        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="email">E-posta</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="ornek@email.com"
            />
          </FormGroup>

          {error && <ErrorMessage>{error}</ErrorMessage>}

          <Button type="submit" fullWidth disabled={loading}>
            {loading ? 'Gönderiliyor...' : 'Şifre Sıfırlama Linki Gönder'}
          </Button>

          <BackButton onClick={() => navigate('/')}>
            Giriş Sayfasına Dön
          </BackButton>
        </form>
      </Card>
    </Container>
  );
};

